import * as Yup from "yup";

import { LicenceType, PricingRuleKeys } from "@sso/types";

const pricingRuleValidation = Yup.object().shape({
  [PricingRuleKeys.PRICE]: Yup.number().required("required").moreThan(0, "value < 0"),
  [PricingRuleKeys.MAX_RANGE]: Yup.number().when("isLast", {
    is: false,
    then: Yup.number().required("required").moreThan(Yup.ref(PricingRuleKeys.MIN_RANGE), "Min > Max"),
    otherwise: Yup.number(),
  }),
});

export const pricingSchemeValidation = Yup.object({
  pricingRules: Yup.array().when("licenceType", {
    is: (value: string) => value === LicenceType.CONCURRENT,
    then: Yup.array().of(pricingRuleValidation),
    otherwise: Yup.array(),
  }),
  apiPricingRules: Yup.array().when("licenceType", {
    is: (value: string) => value === LicenceType.API,
    then: Yup.array().of(
      Yup.object().shape({
        pricingRules: Yup.array().of(pricingRuleValidation),
      }),
    ),
    otherwise: Yup.array(),
  }),
});

export const AddCurrencyPricingRuleValidation = Yup.object().shape({
  [PricingRuleKeys.PRICE]: Yup.number().required("required").moreThan(0, "value < 0"),
});

export const addCurrencyValidation = Yup.object({
  currencyCode: Yup.string().required("Currency is required"),
  pricingRules: Yup.array().when("licenceType", {
    is: (value: string) => value === LicenceType.CONCURRENT,
    then: Yup.array().of(AddCurrencyPricingRuleValidation),
    otherwise: Yup.array(),
  }),
  apiPricingRules: Yup.array().when("licenceType", {
    is: (value: string) => value === LicenceType.API,
    then: Yup.array().of(
      Yup.object().shape({
        pricingRules: Yup.array().of(AddCurrencyPricingRuleValidation),
      }),
    ),
    otherwise: Yup.array(),
  }),
});

export const editMultiCurrencyValidation = Yup.object({
  dateOfEffect: Yup.string().required("Date of Effect is required"),
  currencyCode: Yup.string().required("Currency is required"),
  pricingRules: Yup.array().when("licenceType", {
    is: (value: string) => value === LicenceType.CONCURRENT,
    then: Yup.array().of(AddCurrencyPricingRuleValidation),
    otherwise: Yup.array(),
  }),
  apiPricingRules: Yup.array().when("licenceType", {
    is: (value: string) => value === LicenceType.API,
    then: Yup.array().of(
      Yup.object().shape({
        pricingRules: Yup.array().of(AddCurrencyPricingRuleValidation),
      }),
    ),
    otherwise: Yup.array(),
  }),
});
